// src/hooks/useHeaderHeight.js
import { useEffect, useState } from 'react';

/**
 * Returns the dynamic height of the header element for layout adjustments.
 *
 * @param {string} selector - CSS selector for the header element (default: '#sos_header')
 * @return {number|null} The height of the header in pixels
 */
const useHeaderHeight = (selector = '#sos_header') => {
  const [headerHeight, setHeaderHeight] = useState(null);

  useEffect(() => {
    const updateHeaderHeight = () => {
      const header = document.querySelector(selector);
      setHeaderHeight(header?.offsetHeight || 0);
    };

    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);

    return () => {
      window.removeEventListener('resize', updateHeaderHeight);
    };
  }, [selector]);

  return headerHeight;
};

export default useHeaderHeight;
